// src/services/crmCentre.js — LE CENTRE DU CRM, côté serveur : ses alertes
// (la même liste que lit l'assistant), le réglage de la personne (qui la suit
// d'un poste à l'autre) et les alertes mises de côté.
//
// Le serveur est la seule vérité. Tant qu'une route manque (404 sans notre
// JSON, ou 501), la réponse le DIT (`absente`) : l'écran retombe sur ce qu'il
// sait calculer seul et sur le réglage gardé dans ce navigateur, sans rien
// écrire.
import APIService from './api';

const BASE = 'https://besoins-tat-production.up.railway.app';
const authH = () => ({ Authorization: `Bearer ${APIService.getToken()}` });
const jsonH = () => ({ ...authH(), 'Content-Type': 'application/json' });
const absente = (r, j) => r.status === 501 || (r.status === 404 && j.success !== false);

async function appel(chemin, options = {}) {
  try {
    const r = await fetch(`${BASE}/crm/centre${chemin}`, options);
    const j = await r.json().catch(() => ({}));
    if (absente(r, j)) return { ok: false, absente: true };
    if (!r.ok || j.success === false) return { ok: false, status: r.status, error: j.error || `Impossible (${r.status})` };
    return { ok: true, data: j.data };
  } catch (e) { return { ok: false, error: e.message }; }
}

export const lireAlertes = (clientId = null) => appel(`/alertes${clientId != null ? `?client_id=${encodeURIComponent(clientId)}` : ''}`, { headers: authH() });
export const lireReglage = () => appel('/reglage', { headers: authH() });
/** { actions?: string[] | null, alertes?: { retard: true, … } } — ce qui est fourni change, le reste est gardé. */
export const ecrireReglage = (reglage) => appel('/reglage', { method: 'PUT', headers: jsonH(), body: JSON.stringify(reglage) });
export const mettreDeCote = (cle, { jours = 7, note = '' } = {}) => appel('/alertes/de-cote', { method: 'POST', headers: jsonH(), body: JSON.stringify({ cle, jours, note: note || null }) });
export const remettre = (cle) => appel(`/alertes/de-cote/${encodeURIComponent(cle)}`, { method: 'DELETE', headers: authH() });
